/**
 * @license @lucide/lab v0.1.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const typeSquare = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 9V7h10v2", key: "oq86z9" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M10 17h4", key: "pvmtpo" }]
];

export { typeSquare as default };
//# sourceMappingURL=type-square.js.map
